import Layout from "../../../components/layout/layout.js";

import PIScoreForm from "../../../components/form/pi-score.js";

function PIScorePage({ component, ...rest }) {
  return <Layout Component={PIScoreForm} {...rest} controlsDisabled={true} />;
}

export default PIScorePage;
